<div class="stat-card" [ngClass]="'stat-card--' + tone" role="group" [attr.aria-label]="accessibleText" [title]="accessibleText">
  <div class="stat-card__icon">
    <i [class]="icon" aria-hidden="true"></i>
  </div>
  <div class="stat-card__body">
    <div class="stat-card__value">{{ value }}</div>
    <div class="stat-card__label">{{ label }}</div>
  </div>
  <span class="stat-card__bar"></span>
</div>
